import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import IPage from 'models/Page';
import { PageEditFormProps } from '../pageEditRegistry';
import TimerForm from 'pages/OwnerPage/QuizFormPage/TabContentPages/Timer/TimerForm';

const TimerPageForm: FC<PageEditFormProps> = ({ pageRef }) => {
  const { watch } = useFormContext();
  const pages: IPage[] = watch('pages') || [];
  const page = pages.find((p: IPage) => p.uuid === pageRef);
  const timerRef = page?.refs?.[0];

  if (!timerRef) return null;

  return <TimerForm timerRef={timerRef} />;
};

export default TimerPageForm;
